<div
	[ngClass]="cssClassesMap[status]"
	[ngStyle]="{ cursor: isClickable ? 'pointer' : 'default' }"
	[matRippleDisabled]="!isClickable"
	[matTooltip]="tooltip"
	matTooltipPosition="below"
	class="progress-label"
	matRipple
	(click)="$event.stopPropagation()"
>
	{{ status | translate }}
</div>
